import { DocumentApi } from '@/modules/document/api/document.api.ts';
import AddLinkIcon from '@/assets/icons/document/add-link.svg?component';
import AddClientIcon from '@/assets/icons/document/add-client.svg?component';
import CardLinkTypes from '@/modules/document/document-master/CardLinkTypes.vue';
import { SchemaSearchMultiple } from '@/modules/ui/models/schema/schema-search-multiple.ts';
import { CounterpartyApi } from '@/modules/shared/feature-bridges.ts';

export const SCHEMA_LINKS = new SchemaSearchMultiple({
  name: 'links',
  label: 'document.ui.searchMultiple.linkedDocuments',
  collapsible: true,
  showCount: true,
  placeholder: 'document.ui.common.placeholder.documentNumber',
  getOptions: DocumentApi.getOptions,
  addIcon: AddLinkIcon,
  addText: 'ui.searchMultiple.addText.links',
  getCard: DocumentApi.getDocument,
  cardFooter: CardLinkTypes,
});

export const SCHEMA_CLIENTS = new SchemaSearchMultiple({
  name: 'clients',
  label: 'document.counterparty.title.list',
  collapsible: true,
  showCount: true,
  placeholder: 'document.ui.common.placeholder.counterparties',
  getOptions: CounterpartyApi.getOptions,
  addIcon: AddClientIcon,
  addText: 'ui.searchMultiple.addText.counterparties',
  getCard: CounterpartyApi.getClient,
  cardFooter: CardLinkTypes,
});
